var formControls = require('form/controls');

if($('#formTemoignage').length){
    $('#formTemoignage').on('submit',function(event) {
        var text = "Veuillez renseigner ce champ.";
        var notice_name = $('#notice-name',$('#formTemoignage')).val();
        var notice_city = $('#notice-city',$('#formTemoignage')).val();
        var notice_email = $('#notice-email',$('#formTemoignage')).val();
        var notice_title = $('#notice-title',$('#formTemoignage')).val();
        var notice_text = $('#notice-text',$('#formTemoignage')).val();
        var hasError = false;


        if(notice_name === "") {
            formControls.showError($('#notice-name', $('#formTemoignage')), text);
            hasError = true;
        }

        if(notice_city === "") {
            formControls.showError($('#notice-city', $('#formTemoignage')), text);
            hasError = true;
        }

        if(notice_email === "") {
            formControls.showError($('#notice-email', $('#formTemoignage')), text);
            hasError = true;
        }

        if(notice_title === "") {
            formControls.showError($('#notice-title', $('#formTemoignage')), text);
            hasError = true;
        }

        if(notice_text === "") {
            formControls.showError($('#notice-text', $('#formTemoignage')), text);
            hasError = true;
        }

        if(hasError) {
            event.preventDefault();
            return false;
        }
    });
}
